import styled from '@emotion/styled';
import {
  Button,
  DialogActions,
  DialogContent as _DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
} from '@material-ui/core';
import { List } from 'immutable';
import { ClassAttributes, createElement, FC, MouseEvent, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import AmazonAdAccount from '../../../entity/AmazonAdAccount';
import { SPACING_REGULAR } from '../../constant/spacing';
import Dialog from '../primitive/DialogWithPadding';
import AmazonAdAccountList from './AmazonAdAccountList';

type Props = ClassAttributes<HTMLElement> & {
  amazonAdAccounts: List<AmazonAdAccount>;
  open: boolean;
  onRequestSendingCreative: (e: MouseEvent<HTMLElement>, amazonAdAccount: AmazonAdAccount) => void;
  onRequestClose: () => void;
  className?: string;
};

const IntegrateAmazonAdAccountDialog: FC<Props> = ({
  amazonAdAccounts,
  open,
  onRequestSendingCreative,
  onRequestClose,
  className,
}) => {
  const [selectedAdAccount, setSelectedAdAccount] = useState<AmazonAdAccount | null>(null);
  const onClickAdAccount = (_: any, selected: AmazonAdAccount) => setSelectedAdAccount(selected);
  const onClickSendButton = async (e: any) => {
    if (selectedAdAccount !== null) {
      await onRequestSendingCreative(e, selectedAdAccount);
    }
    onRequestClose();
  };

  return (
    <Dialog open={open} onRequestClose={onRequestClose} className={className} maxWidth="md">
      <DialogTitle disableTypography>
        <Typography variant="h6">
          <FormattedMessage id="integrate_amazon_ad_account_dialog.title" />
        </Typography>
        <Description>
          <FormattedMessage id="integrate_amazon_ad_account_dialog.description" />
        </Description>
      </DialogTitle>

      <ContentLayout>
        <DialogContent>
          <AmazonAdAccountList
            amazonAdAccounts={amazonAdAccounts}
            selected={selectedAdAccount}
            onClick={onClickAdAccount}
          />
        </DialogContent>
      </ContentLayout>

      <DialogActions>
        <Button disabled={!selectedAdAccount} onClick={onClickSendButton}>
          <FormattedMessage id="integrate_amazon_ad_account_dialog.send" />
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const Description = styled(DialogContentText)({
  marginTop: SPACING_REGULAR,
});

const ContentLayout = styled('div')({
  display: 'flex',
  justifyContent: 'center',
});

const DialogContent = styled(_DialogContent)({
  paddingTop: '0 !important',
  paddingBottom: 0,
  maxWidth: 750,
});

export default IntegrateAmazonAdAccountDialog;
